import React from 'react'

import ArrowRight from '../../../assets/icons/arrow-right.svg?react'
import DotsArrowRight from '../../../assets/icons/dots-arrow-right.svg?react'
import LinkWithIcon from '../layout/LinkWithIcon'

type Props = { label: string, linkTo: string, replace?: boolean, iconClassName?: string, linkColor?: string, size?: 'sm' | 'lg' }
const SeeAllLink: React.FC<Props> = ({ label, linkTo, replace, iconClassName, linkColor, size = 'sm' }) => {
  return (
    <LinkWithIcon label={label} linkTo={linkTo} replace={replace} icon={size === 'lg' ? <DotsArrowRight /> : <ArrowRight />} iconClassName={iconClassName} linkColor={linkColor} size={size} />
  )
}

export default SeeAllLink
